import React, { memo } from 'react';

interface AtrapaRitmoHudProps {
  timeLeftMs: number;
  durationMs: number;
  score: number;
  streak: number;
  feedback: 'hit' | 'miss' | 'combo' | null;
}

export const AtrapaRitmoHud = memo(function AtrapaRitmoHud({
  timeLeftMs,
  durationMs,
  score,
  streak,
  feedback,
}: AtrapaRitmoHudProps) {
  const seconds = Math.ceil(timeLeftMs / 1000);
  const progress = durationMs > 0 ? timeLeftMs / durationMs : 0;
  const r = 40;
  const c = 2 * Math.PI * r;
  const dash = c * progress;

  return (
    <div className="shrink-0 grid grid-cols-[auto_1fr_auto] sm:grid-cols-3 gap-2 sm:gap-3 items-stretch">
      <div className="ar-hud-card relative flex items-center justify-center w-[88px] h-[88px] sm:w-[96px] sm:h-[96px] shrink-0">
        <svg width="100%" height="100%" viewBox="0 0 100 100" className="-rotate-90" aria-hidden>
          <circle cx={50} cy={50} r={r} fill="none" stroke="#E2E8F0" strokeWidth={6} />
          <circle
            cx={50}
            cy={50}
            r={r}
            fill="none"
            stroke="#6EE7B7"
            strokeWidth={6}
            strokeLinecap="round"
            strokeDasharray={`${dash} ${c}`}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="ar-hud-value text-2xl sm:text-3xl leading-none">{seconds}</span>
          <span className="ar-hud-label">seg</span>
        </div>
      </div>

      <div
        className={`ar-hud-card flex flex-col items-center justify-center px-4 py-3 sm:py-4 ${
          feedback === 'hit' ? 'ar-pop' : feedback === 'miss' ? 'ar-shake' : ''
        }`}
      >
        <p className="ar-hud-label mb-0.5">Puntos</p>
        <p className="ar-hud-value text-4xl sm:text-5xl leading-none">{score}</p>
      </div>

      <div
        className={`ar-hud-card flex flex-col items-center justify-center px-4 py-3 sm:py-4 min-w-[88px] ${
          streak >= 5 ? 'ar-hud-card--streak' : ''
        }`}
      >
        <p className="ar-hud-label mb-0.5">Racha</p>
        <p className="ar-hud-value text-3xl sm:text-4xl leading-none flex items-center gap-1">
          {streak >= 5 && <span aria-hidden>🔥</span>}
          <span className={streak >= 3 ? 'text-[#818CF8]' : ''}>{streak}</span>
        </p>
      </div>
    </div>
  );
});

export default AtrapaRitmoHud;
